import PropTypes from 'prop-types';
import React from 'react';

import IconBounds from '../IconBounds';
import { Cake } from '../shapes';


const CakeSvg = (props) => (
  <g>
    <IconBounds />
    <Cake {...props} />
  </g>
);

CakeSvg.propTypes = {
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

CakeSvg.defaultProps = {
  fill: '#000',
  stroke: '#000',
  strokeWidth: 1,
};


export default CakeSvg;
